<template>
  <div class="edit-times-event">
    <AppModal v-if="showModal"
              :submitTxt="i18n[locale].btn"
              @close="closeModal"
              :isShowFooter="false">
      <h1 slot="header" @click.stop>{{ i18n[locale].edit_times }} {{ lesson.title }}, {{ lesson.start | showDate }}</h1>
      <div slot="body" class="form" @click.stop>
        <div class="origin-lesson">
          <p class="label">{{ i18n[locale].current_times }}</p>
          <div class="flex border pad-10 relative">
            <p>{{ lesson.title }}</p>
            <div class="lesson_times">
              <div>, kl. {{ $filters.LT(lesson.start) }}</div>
              <div class="lesson_times__seperator"> -</div>
              <div>{{ $filters.LT(lesson.end) }}</div>
            </div>
            <div class="marg-10-left">
              ({{ i18n[locale].duration }}: {{ oldDuration }} {{ i18n[locale].minutes }})
            </div>
          </div>
        </div>
        <h3 class="marg-24-top flex align-center">
          <span class="icon-clock"></span><span class="marg-5-left">
          {{ i18n[locale].new_times }}
        </span>
        </h3>
        <div class="flex align-center edit-times-input-wrapper">
          <TimeChanger
            :start="lesson.start"
            :end="lesson.end"
            addClass="edit-times-inputs"
            @updateStart="updateStartTime"
            @updateEnd="updateEndTime">
          </TimeChanger>
          <div class="marg-10-left">
            ({{ i18n[locale].duration }}: {{ newDuration }} {{ i18n[locale].minutes }})
          </div>
        </div>
        <div class="modal-footer modal-footer__flex">
          <button class="do-bttn" @click.stop="closeModal">
            {{ $t('vue2.common.cancel') }}
          </button>
          <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSubmitting}" @click.stop="submit">
            {{ $t('vue2.common.save') }}
          </button>
        </div>
      </div>
    </AppModal>
  </div>
</template>

<script>
import TimeChanger from '../TimeChanger.vue'
import AppModal from '../common/AppModal'
import docendo from '../../docendo'
import moment from 'moment'

export default {
  components: {AppModal, TimeChanger},
  props: {
    lesson: {
      type: Object
    }
  },
  filters: {
    showDate (dateTime) {
      return moment(dateTime).format('dddd, D. MMM')
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    oldDuration () {
      let duration = moment.duration(moment(this.lesson.end).diff(this.lesson.start))
      return duration.asMinutes()
    },
    newDuration () {
      let duration = moment.duration(moment(this.updatedEndTime).diff(this.updatedStartTime))
      return duration.asMinutes()
    }
  },
  data () {
    return {
      i18n: {
        da: {
          edit_times: 'Rediger tider på',
          current_times: 'Nuværende tider',
          new_times: 'Nye tider',
          duration: 'Varighed',
          minutes: 'minutter',
          btn: 'Gem tider'
        },
        nb: {
          edit_times: 'Rediger tider på',
          current_times: 'Nåværende tider',
          new_times: 'Nye tider',
          duration: 'Lengde',
          minutes: 'minutter',
          btn: 'Lagre tider'
        },
        en: {
          edit_times: 'Edit times on',
          current_times: 'Current times',
          new_times: 'New times',
          duration: 'Duration',
          minutes: 'minutes',
          btn: 'Save times'
        }
      },
      showModal: true,
      updatedStartTime: this.lesson.start,
      updatedEndTime: this.lesson.end,
      isSubmitting: false
    }
  },
  methods: {
    updateStartTime (time) {
      this.updatedStartTime = moment(this.lesson.start).hours(moment(time).hours()).minutes(moment(time).minutes())
    },
    updateEndTime (time) {
      this.updatedEndTime = moment(this.lesson.end).hours(moment(time).hours()).minutes(moment(time).minutes())
    },
    submit () {
      if (this.isSubmitting) return
      this.isSubmitting = true
      const updates = [{
        event_id: this.lesson.id,
        start_time: moment(this.updatedStartTime).toISOString(),
        end_time: moment(this.updatedEndTime).toISOString()
      }]
      docendo.updateEvents(this.lesson.school_id, updates, success => {
        this.isSubmitting = false
        this.$emit('updated')
        this.showModal = false
      }, failure => {
        console.log('failure', failure)
        this.isSubmitting = false
      })
    },
    closeModal () {
      this.$emit('close')
      this.showModal = false
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.lesson_times {
  display: flex;
  align-items: center;
}

.lesson_times__seperator {
  margin: 0 5px;
}

.form {
  padding: 40px;
}

.label {
  text-transform: uppercase;
  color: #a2a3a6;
  font-weight: bold;
  margin-bottom: 0;
}

.edit-times-input-wrapper {
  margin-bottom: 32px;
  margin-top: 8px;
}

.edit-times-input-wrapper >>> .edit-times-inputs input {
  padding: 10px;
  text-align: center;
  max-width: 90px;
  font-size: 16px;
  border: 2px solid #ccc;
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: none;
  background: #ffffff;
  transition: border 0.45s;
}

.edit-times-input-wrapper >>> .edit-times-inputs input:focus {
  border-color: var(--blue);
}

.marg-24-top {
  margin-top: 24px;
}

.modal-footer__flex {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// SubsEventEditTimes.vue?7493a5e9